export class AndroidSender {
  send(event) {
    if (typeof window === 'undefined') {
      return;
    }
    try {
      if (!window.Android || typeof window.Android[event.type] !== 'function') {
        throw new Error();
      }
      if (typeof event.detail !== 'undefined' && event.detail !== null) {
        window.Android[event.type](typeof event.detail === 'object' ? JSON.stringify(event.detail) : event.detail);
      } else {
        window.Android[event.type]();
      }
    } catch (_unused) {
      throw new Error('Could not send event to host application');
    }
  }
}
//# sourceMappingURL=AndroidSender.js.map